"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var moment_1 = __importDefault(require("moment"));
var react_number_format_1 = __importDefault(require("react-number-format"));
var Datum = function (_a) {
    var input = _a.input;
    var handleChange = function (evt) {
        var value = evt.target.value;
        var valueAsMoment = value && (0, moment_1["default"])(value, ['DD.MM.YYYY', 'YYYY-MM-DD', moment_1["default"].ISO_8601], true);
        var valueFormatted = moment_1["default"].isMoment(valueAsMoment) && valueAsMoment.isValid()
            ? valueAsMoment.format('YYYY-MM-DD')
            : value;
        return input.onChange(valueFormatted, evt);
    };
    var handleBlur = function (evt) {
        var value = evt.target.value;
        var valueAsMoment = value && (0, moment_1["default"])(value, ['DD.MM.YYYY', 'YYYY-MM-DD', moment_1["default"].ISO_8601], true);
        var valueFormatted = (moment_1["default"].isMoment(valueAsMoment) && valueAsMoment.isValid())
            ? valueAsMoment.format('YYYY-MM-DD')
            : '';
        input.onChange(valueFormatted);
        return input.onBlur();
    };
    var valueAsMoment = input.value && (0, moment_1["default"])(input.value, ['DD.MM.YYYY', 'YYYY-MM-DD', moment_1["default"].ISO_8601], true);
    var valueFormatted = moment_1["default"].isMoment(valueAsMoment) && valueAsMoment.isValid()
        ? valueAsMoment.format('DD.MM.YYYY')
        : input.value;
    return (react_1["default"].createElement("div", { className: "input-group" },
        react_1["default"].createElement("input", { type: "hidden", name: input.name, value: input.value }),
        react_1["default"].createElement(react_number_format_1["default"], __assign({}, input, { name: "".concat(input.name, "_formatted"), value: valueFormatted, onChange: handleChange, onBlur: handleBlur, format: "##.##.####", placeholder: "TT.MM.JJJJ", mask: "_", className: "form-control" }))));
};
exports["default"] = Datum;
